import { render } from "./Detail.vue?vue&type=template&id=446f710b&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=446f710b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-446f710b"

export default script